import {Box, styled} from "@mui/material";
import React from "react";
import aiSummaryBackground from "../../assets/aiSummaryBackground.png";

export const AISummaryContainer = styled(Box)({
    padding: "10px 20px",
    boxSizing: "border-box",
    background: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5)), url(${aiSummaryBackground}) no-repeat center / cover`,
    color: "#FFFFFF",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    "& li":{
        marginTop: "10px",
        fontSize: "1.8rem",
        fontWeight: 600,
        color: "#FFFFFF",
        zIndex: 2,
        textShadow: "1px 1px 2px black, 0 0 25px black, 0 0 5px black",
        "@media(max-width: 768px)":{
            fontSize: "1rem",
        },
        "& p":{
            fontWeight: 400,
            fontSize: "1.3rem",
        },
        "&>ul>li":{
            fontWeight: 400,
            fontSize: "1.3rem",
        }
    },
    "&>ul>li":{
        padding: "15px",
        background: "rgba(0, 0, 0, 0.6)",
        borderRadius: "8px",
    },
    "&>ul":{
        display: "grid",
    },
    "@media(max-width: 768px)":{
        paddingLeft: 0,
        backgroundPosition: "center 100%",
        gridTemplateColumns: "1fr",
    },
});

const AISummary = ():JSX.Element => {
    return (
        <AISummaryContainer>
            <ul>
                <li>
                    Robust Data Integration:
                    <ul>
                        <li>
                            <b>Comprehensive Data Collection:</b> Our AI systems gather vast amounts of data from diverse financial markets, including real-time data streams from stock markets, bond markets, cryptocurrency exchanges, and economic indicators.
                        </li>
                        <li>
                            <b>Multi-source Aggregation:</b> By integrating data from financial news, social media sentiment, and macroeconomic indicators, our AI provides a holistic view of the investment landscape.
                        </li>
                    </ul>
                </li>
                <li>
                    Advanced Analytical Engine:
                    <ul>
                        <li>
                            <b>Deep Learning Models:</b> Utilizing state-of-the-art deep learning techniques, our AI analyzes complex patterns and trends that affect market movements and asset valuations.
                        </li>
                        <li>
                            <b>Predictive Analytics:</b> Our models predict future market behaviors by learning from historical data, helping to forecast price movements and market trends with high accuracy.
                        </li>
                    </ul>
                </li>
                <li>
                    Real-Time Probability Calculations:
                    <ul>
                        <li>
                            <b>Dynamic Risk Assessment:</b> AI algorithms calculate the probabilities of various market outcomes, allowing for dynamic risk assessment and management tailored to individual risk profiles.
                        </li>
                        <li>
                            <b>Precision in Predictions:</b> By processing vast datasets, our AI delivers predictions with high numerical precision, enabling users to make decisions based on reliable probabilities rather than mere speculation.
                        </li>
                    </ul>
                </li>
                <li>
                    Diverse Investment Analysis:
                    <ul>
                        <li>
                            <b>Equities and Bonds:</b> AI-driven insights into stock and bond markets, providing users with advanced portfolio management tools and investment strategies.
                        </li>
                        <li>
                            <b>Cryptocurrency Specialization:</b> Special algorithms tailored to the volatile nature of cryptocurrencies, offering users insights into potential gains and risk mitigation strategies.
                        </li>
                    </ul>
                </li>
            </ul>
            <ul>
                <li>
                    Personalized Investment Analysis:
                    <ul>
                        <li>
                            <b>Customized Portfolio Suggestions:</b> Based on individual user profiles, which include risk tolerance, financial goals, and investment preferences, our AI suggests optimized investment strategies.
                        </li>
                        <li>
                            <b>Adaptive Learning:</b> Our system adapts to changes in user preferences and market conditions, continuously refining recommendations to suit evolving needs.
                        </li>
                    </ul>
                </li>
                <li>
                    Transparency and Explainability:
                    <ul>
                        <li>
                            <b>Insightful Reporting:</b> We provide users with clear explanations of how decisions are made, what data was considered, and why specific investments could be good for him.
                        </li>
                        <li>
                            <b>User Empowerment:</b> By demystifying the complexities of AI, we empower users to understand and trust the insights provided, fostering confidence in their investment choices.
                        </li>
                    </ul>
                </li>
                <li>
                    Regulatory Compliance and Security:
                    <ul>
                        <li>
                            <b>Data Security:</b> Adherence to the highest standards of data protection and privacy, ensuring all user information and transaction data is securely managed.
                        </li>
                        <li>
                            <b>Compliance First:</b> Our technology is built to comply with all relevant financial regulations and ethical standards, ensuring peace of mind for our users.
                        </li>
                    </ul>
                </li>
            </ul>
        </AISummaryContainer>
    );
};

export default AISummary;
